import { useUnit } from 'effector-react';
import { withTags } from '@src/utils/tags';
import { TUserTag } from '@src/models/auth';
import { userEffectorModel } from '../stores';

/** Хук для проверки юзер тега пользователя */
export const useHasUserTag = (tags: TUserTag | TUserTag[]): boolean => {
  const { $userStore: user } = useUnit(userEffectorModel);

  if (!user) return false;

  return withTags({ tags, user });
};
